import { render, staticRenderFns } from "./ClientEmployees.vue?vue&type=template&id=f4f20f5e&scoped=true&"
import script from "./ClientEmployees.vue?vue&type=script&lang=ts&"
export * from "./ClientEmployees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f20f5e",
  null
  
)

export default component.exports